<template>
  <div style="padding: 20px;">

    <div class="form-title">
      Apports nutritionnels de {{ consumerName }}
    </div>

    <LoaderView v-if="nutrients == null" />

    <div v-else>
      <div v-for="(nutrient, index) in nutrients" :key="index">

        <ProteinGluciesLipidesBar
          v-if="nutrient.name == 'protein_glucides_lipides'"
          :protein="nutrient.protein"
          :glucides="nutrient.glucides"
          :lipides="nutrient.lipides"
        />

        <CenteredNutritionBar
          v-else
          v-bind="nutrient"
        />

      </div>
    </div>

  </div>
</template>

<script>
import LoaderView from '@/components/LoaderView.vue';
import ProteinGluciesLipidesBar from '@/components/ProteinGlucidesLipidesBar.vue';
import CenteredNutritionBar from '@/components/CenteredNutritionBar.vue';
import { api } from "@/api";

export default {
  name: "ApportsIndividuels",
  components: {
    LoaderView,
    ProteinGluciesLipidesBar,
    CenteredNutritionBar,
  },
  data() {
    return {
      nutrients: null,
      consumerName: "",
    };
  },
  created() {
    const id = this.$route.params.id;

    api.get("/nutrition-summary/" + id + "/")
      .then(res => {
        this.nutrients = res.data.nutrients;
        this.consumerName = res.data.name;
      });
  }
};
</script>
